import { EMPTY_OBJECT } from '@unifyapps/carbon/consts/empty';
import type { InterfaceNamespaceEntity } from '@unifyapps/defs/types/namespace';
import { useSearchNamespaces } from '@unifyapps/network/generated/entity-rest-api/entity-rest-api';
import InterfaceHelper from '../../../../../stores/InterfaceStore/helper/InterfaceHelper';
import { useGetUserContext } from '../../../../useGetUserContext';
import type { FetchInterfaceNamespacesParams } from './types';
import { getInterfaceCommonNamespaceSearchRequest } from './utils';

type Namespace = InterfaceNamespaceEntity | undefined;

export const useFetchInterfaceCommonNamespace = (
  props: Omit<FetchInterfaceNamespacesParams, 'interfacePageId'>,
) => {
  const { userContext } = useGetUserContext();
  const { interfaceId, interfaceRecord, mode, queryOptions } = props;

  const userLocale = userContext?.locale;
  const locale = InterfaceHelper.getLocale({
    userLocale,
    interfaceRecord,
    mode,
    localeFromCookie: props.locale,
  });
  const interfaceDefaultLocale = InterfaceHelper.getDefaultLocale(interfaceRecord);

  const {
    data: commonNamespaceData,
    isLoading,
    error,
  } = useSearchNamespaces(
    getInterfaceCommonNamespaceSearchRequest({
      interfaceId,
      locale,
    }),
    {
      query: {
        enabled: Boolean(interfaceDefaultLocale),
        retry: 3,
        staleTime: Infinity,
        ...(queryOptions ? queryOptions : EMPTY_OBJECT),
      },
    },
  );

  return {
    isLoading,
    error,
    commonNamespace: commonNamespaceData?.objects?.[0] as Namespace,
  };
};
